/**
 * MicroFrontend-related Events
 * TODO: move to microfrontend-utils?
 * @type {{MOUNT: string, UNMOUNT: string, 'UPDATE:pageHeaderActionsContainer': string, 'UPDATE:pageHeaderTitleExtras': string}}
 */
const mfeEvents = {
    MOUNT: 'MOUNT',
    UNMOUNT: 'UNMOUNT',
    'UPDATE:pageHeaderActionsContainer': 'UPDATE:pageHeaderActionsContainer',
    'UPDATE:pageHeaderTitleExtras': 'UPDATE:pageHeaderTitleExtras',
}

export default mfeEvents
